import { BuildProduct } from './../constants/actionType'
const initialState = {
    getsoc: {
        socResponse: null
    },
    postsoc: "",
    socInvoked:false
}

function firstBill(state = initialState, action) {
    switch (action.type) {    	
      case 'POST_SOC': 
        let postsoc = Object.assign({}, state.postsoc, {
            postsocmsg: action.value
        })
        return Object.assign({}, state, {
            postsoc: postsoc
        }) 
      case "GET_SOC":
        let getsoc = Object.assign({}, state.getsoc, {
            socResponse: action.value
        })
        return Object.assign({}, state, {
            getsoc: getsoc
        })
      case BuildProduct.socInvoked:
        return Object.assign({}, state, {
            socInvoked: action.value
        })
      default:
              return state
    }

}

export default firstBill